import React from 'react'
import Layout from '../../../layout'
import TextWithImg from '../../common/TextWithImg';
import Service from './Service'
import SystemTradesWhy from './SystemTradesWhy';
import { makeStyles } from '@material-ui/core/styles'
import { Box, Hidden } from '@material-ui/core'
import TitlePage from '../../common/TitlePage';
import SystemTrades from "./SystemTrades";
import SystemDownloadFile from "./SystemDownloadFile";
import DonloadPdf from './../Education/download';

const useStyles = makeStyles((theme) => ({

    details: {
        width: '50%',
        margin: 'auto',
        borderRadius: 15,
        boxShadow: `0px 0px 36px rgba(0, 0, 0, 0.161)`,
        marginBottom: 30,
        padding: "20px 27px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down('sm')]: {
            width: "98%",
        }

    },
    item: {
        display: "flex",
        alignItems: "center",
        flexDirection: 'column',
        color: "black",
        fontSize: "1rem",
        fontWeight: 'bold',
        "& > div": {
            width: "100%",
            textAlign: 'center'
        },

    },
    color: {
        color: theme.palette.light.type2
    },

}))


export default function Trades() {

    const classes = useStyles()

    return (
        <Layout>
            <SystemTrades />
            <DonloadPdf />
            <br />    <br />    <br />    <br />
            <SystemDownloadFile />
            <TextWithImg data={data} />
            <Service />
            {/* <div className={classes.details}>
                <Box className={classes.item}>
                    <TitlePage position="bottomCenter" padding="20px 27px">
                        شماره حساب‌ کارگزاری <span className={classes.color}>پویان</span>
                    </TitlePage>
                    <hr style={{ width: '100%' }} />
                    <p>بانک تجارت </p>
                    <p>104350712</p>
                </Box>
            </div> */}
        </Layout>
    )
}


let data = {
    title: "سامانه معاملات آنلاین ",
    content: 'سامانه معاملات برخط، یک نرم‌افزار معاملاتی است که برای خرید و فروش سهام به‌صورت آنلاین و مستقیم استفاده می‌شود. با استفاده از سامانه معاملات آنلاین، می‌توانیم در هر موقعیت جغرافیایی و صرفا با استفاده از یک تلفن همراه ترید کنیم. سامانه‌های برخط مشکلات مرسوم نظیر تاخیر در اجرای سفارشات، اشتباه در قیمت یا حجم معامله و... را ندارند. ',
    // src: "trades1.png"
    src: "trades1.jpg"
}

